import { usePage } from "@inertiajs/react"
import { NativeTabs } from "@ruby-native/react"
import type { PropsWithChildren } from "react"

import { AppContent } from "@/components/app-content"
import { AppHeader } from "@/components/app-header"
import { AppShell } from "@/components/app-shell"
import type { BreadcrumbItem } from "@/types"

export default function AppHeaderLayout({
  children,
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
}>) {
  const page = usePage()
  const { nativeApp } = page.props
  const { user_signed_in, user } = page.props.auth

  return (
    <AppShell>
      {user && user_signed_in && <NativeTabs />}
      {!nativeApp && <AppHeader />}
      <AppContent>{children}</AppContent>
    </AppShell>
  )
}
